import { getTranslation } from '@/hooks/useTranslation';

const title = getTranslation('nav.routes.tools.historyTitle') || 'Tool history';

const ToolsHistoryRouteNavigationOptions = {
  title,
  headerTitle: title,
  headerBackVisible: true,
};

export default ToolsHistoryRouteNavigationOptions;
